import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-[260px_1fr]",
  style: {
    "min-height": "360px"
  }
};
const _hoisted_2 = {
  class: "flex items-start justify-center pt-10 px-4",
  style: {
    "background": "#e3f2fd"
  }
};
const _hoisted_3 = {
  class: "text-subtitle-1 font-weight-bold text-primary text-center leading-tight"
};
const _hoisted_4 = {
  class: "flex flex-col items-center justify-center px-8 py-10 bg-white"
};
const _hoisted_5 = {
  class: "text-6xl mb-4"
};
const _hoisted_6 = {
  class: "text-h5 font-weight-bold text-deep-orange-darken-1 mb-3 text-center"
};
import LlHtmlViewerIframe from '@/components/LlHtmlViewerIframe.vue';
export default {
  __name: 'SettlementGate',
  props: {
    /** Emoji icon displayed large above the title */
    icon: {
      type: String,
      required: true
    },
    /** Gate title text */
    title: {
      type: String,
      required: true
    },
    /** HTML for the sidebar label (supports <br>) */
    sidebarLabel: {
      type: String,
      required: true
    },
    /** data-cy attribute for testing */
    dataCy: {
      type: String,
      default: 'settlement-gate'
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        variant: "outlined",
        class: "mb-6 overflow-hidden",
        style: {
          "min-height": "360px"
        },
        "data-cy": __props.dataCy
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createVNode(LlHtmlViewerIframe, {
          "html-content": __props.sidebarLabel
        }, null, 8, ["html-content"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.icon), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.title), 1), _renderSlot(_ctx.$slots, "default")])])]),
        _: 3
      }, 8, ["data-cy"]);
    };
  }
};